module.exports = __webpack_public_path__ + "img/map_1791448249246_67300.1d0ca2c7.gif";